import { render, staticRenderFns } from "./BotCreator.vue?vue&type=template&id=9c09c080&"
import script from "./BotCreator.vue?vue&type=script&lang=js&"
export * from "./BotCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports